import { Controller } from "@hotwired/stimulus";

// Wraps a trigger button and a Ui::ModalComponent panel. See the component's
// class comment for the expected markup shape.
export default class extends Controller {
  static targets = ["root"];

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this);
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown);
  }

  open() {
    this.rootTarget.classList.remove("hidden");
    this.rootTarget.classList.add("flex");
    document.addEventListener("keydown", this.boundKeydown);
  }

  close() {
    this.rootTarget.classList.add("hidden");
    this.rootTarget.classList.remove("flex");
    document.removeEventListener("keydown", this.boundKeydown);
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close();
  }
}
